import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Get } from "../Axios/AxiosFunctions";
import BodyLoader from "../Components/BodyLoader";
import { URL } from "../Config/apiUrl";
import ReactHtmlParser from "react-html-parser";

const TermsAndConditions = () => {
  const [isApiCall, setIsApiCall] = useState(true);
  const [data, setData] = useState("");

  //   getData
  const getData = async () => {
    const url = URL("general/terms-and-policy?key=terms-and-policy");
    setIsApiCall(true);
    const response = await Get(url);
    setIsApiCall(false);

    if (response !== undefined) {
      setData(response.data?.data?.description);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <Container>
      <section>
        <h1 className="terms-heading">Terms & Conditions</h1>
        <div className="text-section">
          {data && ReactHtmlParser(data)}
          {data && ReactHtmlParser(data)}
        </div>
      </section>
    </Container>
  );
};

export default TermsAndConditions;
